/**
 * Converts a UTC date string in the format 2019-11-26 00:48:22 to
 * a native Date object in the local time
 *
 * Required for browsers that do not support the latest date standard
 * (like modern safari and older versions of ie), so we have to parse
 * it ourselves
 */
function convertISOStringToDate(date) {
	const segments = date.split(/\D+/);
	return new Date(
		Date.UTC(
			// Year
			segments[0],
			// Takes months as 0-11 (Jan-Dec), so we need to subtract one
			--segments[1],
			// Day
			segments[2],
			// Hour
			segments[3],
			// Minute
			segments[4],
			// Second
			segments[5]
		)
	);
}

function convertNumberToMonth(monthNumber) {
	const months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];

	return months[monthNumber];
}

function formatDate(utcDate) {
	if (!utcDate) return utcDate;

	const dateObject = convertISOStringToDate(utcDate);

	const month = convertNumberToMonth(dateObject.getMonth());
	const dayOfMonth = dateObject.getDate();
	const year = dateObject.getFullYear();

	const formattedString = `${month} ${dayOfMonth}, ${year}`;

	return formattedString;
}

export function formatPhoneNumber(value) {
	if (!value) return value;

	const regex = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

	return !regex[2]
		? regex[1]
		: `(${regex[1]}) ${regex[2]}${regex[3] ? `-${regex[3]}` : ''}`;
}

export default {
	install(Vue) {
		Vue.filter('formatDate', formatDate);
		Vue.filter('formatPhoneNumber', formatPhoneNumber);
	},
};
